<template>
  <div class="login-view">
    <div class="login-content">
      <h1>Return to Cinch</h1>
      <p>Opening the Cinch app...</p>

      <button class="button home-btn" @click="returnToApp">Return to the app</button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

let redirectTimeout = null

const returnToApp = () => {
  window.location.replace('cinch://login')
}

onMounted(() => {
  // Try to open the app immediately
  returnToApp()

  // If we're still in the browser after 10 seconds, go home
  redirectTimeout = setTimeout(() => {
    router.push('/')
  }, 10000)
})

onUnmounted(() => {
  if (redirectTimeout) {
    clearTimeout(redirectTimeout)
  }
})
</script>

<style scoped>
.login-view {
  padding: 2rem;
  text-align: center;
}

@media (max-width: 450px) {
  .login-view {
    padding: 1rem;
  }
}

.login-content {
  max-width: 500px;
  margin: 0 auto;
}

h1 {
  color: var(--color-heading);
  margin-bottom: 1rem;
  font-size: 2rem;
}

@media (max-width: 450px) {
  h1 {
    font-size: 1.5rem;
  }
}

p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.home-btn {
  padding: 1rem 2rem;
  font-size: 1.1rem;
  margin-top: 0.5rem;
}

@media (max-width: 450px) {
  .home-btn {
    padding: 0.85rem 1.5rem;
    font-size: 1rem;
  }
}
</style>
